import React, { useState } from 'react';
import { QuizItem } from '../../lib/supabase';
import './module-player.scss';

interface QuizStepProps {
    item: QuizItem;
    onComplete: (correct: boolean) => void;
}

export const QuizStep: React.FC<QuizStepProps> = ({ item, onComplete }) => {
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const [answered, setAnswered] = useState(false);

    const handleAnswer = (idx: number) => {
        if (answered) return;
        setSelectedIndex(idx);
        setAnswered(true);

        const isCorrect = idx === item.correctIndex;

        // Auto-proceed after animation
        setTimeout(() => {
            onComplete(isCorrect);
        }, 1800);
    };

    return (
        <div className="quiz-step">
            <div className="quiz-question-card">
                <div className="question-icon">
                    <span className="material-symbols-outlined">quiz</span>
                </div>
                <h2 className="question-text">{item.question}</h2>
            </div>

            <div className="options-grid">
                {item.options.map((opt, idx) => {
                    let optionClass = 'option-card';
                    if (answered) {
                        if (idx === item.correctIndex) {
                            optionClass += ' correct';
                        } else if (idx === selectedIndex) {
                            optionClass += ' incorrect shake';
                        } else {
                            optionClass += ' dimmed';
                        }
                    }

                    return (
                        <button
                            key={idx}
                            className={optionClass}
                            onClick={() => handleAnswer(idx)}
                            disabled={answered}
                        >
                            <span className="option-letter">{String.fromCharCode(65 + idx)}</span>
                            <span className="option-text">{opt}</span>
                            {answered && idx === item.correctIndex && (
                                <span className="material-symbols-outlined result-icon correct-icon">check_circle</span>
                            )}
                            {answered && idx === selectedIndex && idx !== item.correctIndex && (
                                <span className="material-symbols-outlined result-icon incorrect-icon">cancel</span>
                            )}
                        </button>
                    );
                })}
            </div>

            {answered && selectedIndex !== item.correctIndex && (
                <div className="wrong-answer-banner">
                    <span className="material-symbols-outlined">info</span>
                    <span>Doğru cevap: <strong>{item.options[item.correctIndex]}</strong></span>
                </div>
            )}

            {answered && selectedIndex === item.correctIndex && (
                <div className="correct-answer-banner">
                    <span className="material-symbols-outlined">celebration</span>
                    <span>Doğru cevap!</span>
                </div>
            )}
        </div>
    );
};
